import type { ReferrerCandidate, ReferrerSummary, ReferredByPickerValue } from '../types';

export const referredByPickerKey = (
  row: ReferredByPickerValue | ReferrerCandidate,
): string => {
  if ('sourceId' in row) return `${row.kind}:${row.sourceId}`;
  if (row.kind === 'patient' && row.patientId) return `patient:${row.patientId}`;
  if (row.kind === 'staff' && row.staffId) return `staff:${row.staffId}`;
  if (row.referrerId) return `${row.kind}:${row.referrerId}`;
  return `${row.kind}:${row.name}`;
};

export const candidateToPickerValue = (row: ReferrerCandidate): ReferredByPickerValue => ({
  kind: row.kind,
  name: row.name,
  phone: row.phone,
  code: row.code,
  patientId: row.kind === 'patient' ? row.sourceId : undefined,
  staffId: row.kind === 'staff' ? row.sourceId : undefined,
  referrerId: row.kind === 'external' ? (row.referrerId ?? row.sourceId) : row.referrerId,
});

export const pickerValueToCandidate = (row: ReferredByPickerValue): ReferrerCandidate => ({
  kind: row.kind,
  sourceId:
    row.kind === 'patient'
      ? row.patientId ?? row.referrerId ?? ''
      : row.kind === 'staff'
        ? row.staffId ?? row.referrerId ?? ''
        : row.referrerId ?? '',
  name: row.name,
  phone: row.phone ?? '',
  code: row.code ?? '',
  referrerId: row.referrerId,
});

export const summaryToPickerValue = (row: {
  id: string;
  kind: ReferredByPickerValue['kind'];
  name: string;
  code?: string;
  phone?: string;
  patientId?: string;
  staffId?: string;
}): ReferredByPickerValue => ({
  kind: row.kind,
  name: row.name,
  phone: row.phone,
  code: row.code,
  referrerId: row.id,
  patientId: row.patientId,
  staffId: row.staffId,
});

export const summaryToCandidate = (row: ReferrerSummary): ReferrerCandidate =>
  pickerValueToCandidate(summaryToPickerValue(row));

export const buildReferredByWritePayload = (
  value: ReferredByPickerValue | null,
): { referrer: string } | { patient: string } | { staff: string } | null => {
  if (!value) return null;
  if (value.kind === 'patient' && value.patientId) return { patient: value.patientId };
  if (value.kind === 'staff' && value.staffId) return { staff: value.staffId };
  if (value.referrerId) return { referrer: value.referrerId };
  return null;
};
